/**
 * Created by chenrozenes on 21/12/2017.
 */

export const DEFAULT_FLOW_NAME = 'dFlow';
export const TRUE_RESULT = 'true';
export const FALSE_RESULT = 'false';
